import React, { Fragment } from 'react';
import Navbar from '../components/header/Navbar';
import HeroHome from '../components/HeroHome';
import Services from '../components/Services';
import Technology from '../components/Technology';
import ContactUs from '../components/ContactUs';
import Footer from '../components/Footer';

const Home = () => {
    return (
        <Fragment>
            <Navbar />
            <HeroHome />
            <Services />
            <Technology />
            <ContactUs id="contact_us"/>
            <Footer />
        </Fragment>
    );
}

export default Home;